<div class="day-row">
  <div class="day-cell" *ngFor="let dayCell of grid.dayCellData" [style.flex-grow]="dayCell.duration">
    <h2 class="day-number-text">{{ dayCell.date | DateTime: 'DAY_WEEKDAY' }}</h2>
  </div>
</div>
<vdw-regimes-indicator></vdw-regimes-indicator>
